import { EBENEN } from '../../config/ebenen';
import type { ErklaerInhalt } from '../../components/Erklaerung';

// Wörter der Konto-Seite (Profil-Nachbau F-02, F-19; BAU-EINSTELLUNGEN.md B1.9) aus config/ebenen.ts. Leiste, Bereichsname und
// „Schließen“ des Fensters „Einstellungen“ stehen seit F-26 für alle drei Seiten in config/ebenen.ts (EINSTELLUNGEN.titel,
// EINSTELLUNGEN.bereichSchliessen).
export const KONTO_TEXTE = {
  inhaltName: EBENEN.meineEinstellungen, // <main> der Konto-Seite
} as const;

// Wörter der Profil-Seite (Profil-Nachbau F-02, BAU-EINSTELLUNGEN.md B4.5, PF-08). Titel, Satz und Frage zu „Alle Sitzungen
// beenden“ stehen nur in SITZUNGEN_TEXTE (SitzungenBeenden.tsx).
export const PROFIL_TEXTE = {
  untertitel: (produkt: string) => `Ihre persönlichen Angaben und wie andere Sie in ${produkt} sehen.`,
  abschnittAngaben: 'Persönliche Angaben',
  rechnungsHinweis: 'Der Name auf Rechnungen ändert sich dadurch nicht.',
  speichern: 'Änderungen speichern',
  verwerfen: 'Verwerfen',
  emailAendern: 'Ändern …',
  emailAendernName: 'E-Mail-Adresse ändern …',
  emailErklaerung: 'Für die Anmeldung und Nachrichten zu Ihrem Konto.',
  abschnittZugehoerigkeit: 'Zugehörigkeit',
  kontoSeitWeg: 'Meine Daten',
  geraeteAnsehen: 'Geräte ansehen',
} as const;

/** F-24 (PF-TX-rahmen-4, SPEC-rahmen 3.2 F2): der Ablauf des E-Mail-Wechsels im Fenster (bis F-24 Aufklapper „So läuft die
 *  Änderung ab“). Teil 1 nach account/service.ts (Passwort nötig, Hinweis an die bisherige Adresse), Teil 2 nach der Meldung
 *  nach dem Senden (60 Minuten). */
export const EMAIL_FENSTER: ErklaerInhalt = {
  frage: 'Wie läuft die Änderung ab?',
  teile: [
    { titel: '1. Anfordern', text: 'Mit „Ändern …“ tragen Sie die neue Adresse und Ihr Passwort ein. Ihre bisherige Adresse erhält einen Hinweis.' },
    { titel: '2. Bestätigen', text: 'Die neue Adresse gilt erst, wenn Sie den Link bestätigen, den nur die neue Adresse erhält. Er gilt 60 Minuten.' },
    { titel: '3. Neu anmelden', text: 'Danach melden Sie sich mit der neuen Adresse an. Alle bestehenden Anmeldungen enden.' },
  ],
};
